export const ObjectNames = {

    //constant for Custom Rule
    customRulesConstant: {
        moduleTypeId: 65
    },
    //Constants for Product Inventory
    productConstants: {
        //Product Type
        Inventory_Types_Object: "Product Type",
        Inventory_Types_TypeId: 96,
        Inventory_Types_TypeName: "Stages",

        //Product Template
        Inventory_Template_Object: "Product Template",
        Inventory_Template_TypeId: 99,
        Inventory_Template_TypeName: "Template",

        //Product Field Data
        AddFiedTitle: "Add Field Data",
        EditFieldTitle: "Edit Field Data",
        titlewarrantyFieldName: "Warranty",
        warrantyFieldName: "warranty",
        brandFieldName: "brand",
        titleCasebrandFieldName: "Brand",
        colorFieldName: "color",
        titleColorFieldName: "Product Color",
        ProductGroupName: 'Product Group',
        variantFieldName: "variant",

        //Product Visibility
        productVisibility: 'productvisibility',

        //Product Custom Field
        AddCustomTitle: "Add Custom Field",
        EditCustomTitle: "Edit Custom Field",
        productFieldName: "Product",
        customFieldName: "CustomField",
        productcustomFieldName: "ProductCustomFields",
        accountGroup: "Account",
        levelName: "Organization Level",
        AddSectionTitle: "Add New Section",

        //Product Category
        AddCategoryTitle: "Add Category",
        EditCategoryTitle: "Edit Category",
        productCategoryName: "Product Category",
        parentType: "parent",
        childType: "child",
        subChildType: "subChild",
        childSubChildType: "childSubChild",

        //Product UOM
        AddUOMTitle: "Add UOM",
        EditUOMTitle: "Edit UOM",
        UOMPropertyName: "UnitOfMeasure",
        filtertype: "dropdown",
        AddBaseUOMTitle: "Add Base UOM",
        AddNewTitle: "Add New",
        NewType: "new",
        AddRelatedUOMTitle: "Add Related UOM",
        SystemGenerated: "system",
    },

    BehaviorSubjectVariable: "add",

    //Constants for Setup Inventory
    setupConstants: {
        //Payment Term
        PaymentTermName: "PaymentTerm",
        AddPaymentTermTitle: "Add Payment Term",
        AddVendorPaymentTermTitle: "Add Vendor Payment Term",
        EditPaymentTermTitle: "Edit Payment Term",
        EditVendorPaymentTermTitle: "Edit Vendor Payment Term",
        Term: ["NET", "Date Driven", "Other"],

        //Payment Method
        PaymentMethodName: "PaymentMethod",
        AddPaymentMethodTitle: "Add Payment Method",
        AddVendorPaymentMethodTitle: "Add Vendor Payment Method",
        EditPaymentMethodTitle: "Edit Payment Method",
        EditVendorPaymentMethodTitle: "Edit Vendor Payment Method",
        AddPaymentTypeTitle: "Add New Type",

        //Shipping Method
        AddShippingMethodTitle: "Add Delivery Method",
        EditShippingMethodTitle: "Edit Delivery Method",
        parentType: "parent",
        childType: "child",

        //Shipping Term
        AddShippingTermTitle: "Add Shipping Term",
        EditShippingTermTitle: "Edit Shipping Term",

        //Order Source
        AddOrderSourceTitle: "Add Order Source",
        EditOrderSourceTitle: "Edit Order Source",
        OrderSource_Name: "OrderSourceType",

        //FOB Point
        AddFOBTitle: "Add FOB Point",
        EditFOBTitle: "Edit FOB Point",
        shippingAccount: 'Shipping',

        //Discount
        AddDiscountTitle: "Add Discount",
        EditDiscountTitle: "Edit Discount",
        Discount_Name: "Discount Type",
        Limitation_Name: "Limitation Types",
        AmountDiscountType: "Amount",
        PercentageDiscountType: "Percentage",
        incomeAccount: 'Income',
        Limit: ["Unlimited", "N Times only", "N Times per customer"],

        //AdditionalFees
        AddAdditionalFeesTitle: "Add Additional Fees",
        EditAdditionalFeesTitle: "Edit Additional Fees",
        Additionalfees_Name: "AdditionalCharges",
        Limitation_Name1: "Limitation Types",
        AmountDiscountType1: "Amount",
        PercentageDiscountType1: "Percentage",
        incomeAccount1: 'Income',
        Limit1: ["Unlimited", "N Times only", "N Times per customer"],

        //Tax Rate
        AddRateTitle: "Add Rate",
        EditrateTitle: "Edit Rate",

        //Tax Country
        TaxCountryAddDialogHeader: "Add Tax Country"
    },

    //Constants for Location Inventory
    locationConstants: {
        //location
        AddLocationTitle: "Add Location",
        EditLocationTitle: "Edit Location",
        categoryGroupName: "WarehouseCategory",
        typeGroupName: "WarehouseType",
        groupName: "WarehouseGroup",
        AddGroupTitle: "Add New Group",

        //Bin
        AddBinTitle: "Add Bin Detail",
        EditBinTitle: "Edit Bin Detail",
        EditAction: "edit",
        DeleteAction: "delete",
        BinTypeName: "BinType",
        BinTypeOption: ["Manual", "Wizard"],
        separators: [
            { id: 1, name: ":" },
            { id: 2, name: "-" },
        ],
        wizard: [
            {
                id: 1,
                level: "Row or Aisle",
                code: "aisle",
                description: "Number of aisles within each section.",
                prefix: "",
                number: 0,
            },
            {
                id: 2,
                level: "Bay or Racks",
                code: "racks",
                description: "Number of racks in each aisle.",
                prefix: "",
                number: 0,
            },
            {
                id: 3,
                level: "Levels or Shelf",
                code: "levels",
                description: "Number of levels in each rack.",
                prefix: "",
                number: 0,
                childs: []
            },
            // {
            //     id: 4,
            //     level: "Bins",
            //     code: "bins",
            //     description: "Number of bins/positions at each level.",
            //     prefix: "",
            //     number: 0,
            // },
        ],

        //Fields
        AddFieldTitle: "Add Field Data",
        EditFieldTitle: "Edit Field Data",
    },

    customConstants: {
        //Section
        AddSectionTitle: "Add New Section",
        EditSectionTitle: "Edit Section",
        Inventory_Section_Object: "Product Section",
        Inventory_Section_TypeId: 96,
        Inventory_Section_TypeName: "Section",
        Purchase_Section_Object: "Purchase Section",
        Order_Section_Object: "Order Section",
        Order_Fullfillment_Object: "Order Fulfillment Status",
        Order_Back_Order_Object: "Back Order Status",

        //Rule
        Account_Channel_Object: "Account Channel",
        Account_Channel_TypeId: 97,
        Custom_Rule_Options: [
            {
                "name": "Append to all existing records",
                "parentTypeId": 0,
                "description": "Append to all existing records",
                "groupId": 477,
                "group": null,
                "organizationId": 3,
                "colorCodeId": 0,
                "statusId": 1,
                "status": null,
                "id": 1,
                "createdSource": "system",
                "updatedSource": null,
                "createdBy": 9,
                "updatedBy": null,
                "createdDate": "2022-01-01T00:00:00",
                "updatedDate": null
            },
            {
                "name": "Reset all existing records",
                "parentTypeId": 0,
                "description": "Reset all existing records",
                "groupId": 477,
                "group": null,
                "organizationId": 3,
                "colorCodeId": 0,
                "statusId": 1,
                "status": null,
                "id": 2,
                "createdSource": "system",
                "updatedSource": null,
                "createdBy": 9,
                "updatedBy": null,
                "createdDate": "2022-01-01T00:00:00",
                "updatedDate": null
            },
            {
                "name": "New records only",
                "parentTypeId": 0,
                "description": "New records only",
                "groupId": 477,
                "group": null,
                "organizationId": 3,
                "colorCodeId": 0,
                "statusId": 1,
                "status": null,
                "id": 3,
                "createdSource": "system",
                "updatedSource": null,
                "createdBy": 9,
                "updatedBy": null,
                "createdDate": "2022-01-01T00:00:00",
                "updatedDate": null
            },
        ]
    },

    // Constants for Purchase Order
    purchaseOrderConstants: {
        // Template
        Purchase_Template_Object: "Purchase Template",
        PurchaseOrder_Object: "Purchase Order",
        Purchase_Template_TypeId: 99,
        Purchase_Template_TypeName: "Template",

        // Status
        Purchase_Status_Object: "Purchase Status", // use Stages for type and status
        Purchase_Status_TypeId: 96,
        Purchase_Status_TypeName: "Stages",

        // Submodule
        Purchase_Submodule_Object: "Purchase Type",
        Purchase_Submodule_TypeId: 96,
        Purchase_Submodule_TypeName: "Stages",

        // Field Data
        Purchase_Field_Name: "Vendor Type",
        Purchase_Field_Id: 27,
        Purchase_Field_Add_Title: "Add Field Data",
        Purchase_Field_Edit_Title: "Edit Field Data",
        Purchase_Business_Field_Name: "Account Category",
        Purchase_Business_Field_Id: 28,
        Purchase_Number_Of_Employee_Field_Name: "Number Of Employees",
        Purchase_Estimated_Revenue_Field_Name: "Estimated Annual Revenue",
        Purchase_Industry_Field_Name: "Industry",
        Purchase_Ownership_Type_Field_Name: "Ownership Type",
        purchaseFieldName: "Purchases",
        purchasecustomFieldName: "PurchaseCustomFields",
    },

    // Constants for Orders
    OrdersConstants: {
        // Template
        Orders_Template_Object: "Orders Template",
        Orders_Template_TypeId: 99,
        Orders_Template_TypeName: "Template",

        // status
        Orders_Status_Object: "Orders Status", // use Stages for type and status
        Orders_Status_TypeId: 96,
        Orders_Status_TypeName: "Stages",

        // Submodule
        Orders_Submodule_Object: "Orders Type",
        Orders_Submodule_TypeId: 96,
        Orders_Submodule_TypeName: "Stages",
        orderFieldName: "Orders",
        ordercustomFieldName: "OrderCustomFields",

        //orders custom field
        ordersFieldName: "Orders",
        RMA_CustomSectionCode: ['labels_customerreturn_other1', 'labels_customerreturn_other2', 'labels_customerreturn_other3']
    },

    vendorConstants: {
        Vendor_Object: "Vendors",
        Vendor_Title: "Vendor"
    },
    billsConstants: {
        Bills_Object: "Bill Payment",
        Payment_receipts: 'Payment Receipts'
    },
    itemReceiptConstants: {
        receipt_Object: "Item Receipt",
    },
    newBillConstants: {
        newBill_Object: "Bill",
    },
    vendorReturnConstants: {
        vendorReturn_Object: "Vendor Returns",
    },
    vendorCreditConstants: {
        vendorCredit_Object: "Vendor Credit",
    },
    priceBooksConstants: {
        DiscountGroupType: "Discount By Product Group",
        DiscountQtyType: "Discount By Qty",
        PriceTierType: "Price Tier Group",
        PriceRuleConstant: [
            { id: 2, name: "Reset all existing records" },
            { id: 3, name: "New records only" }
        ]
    },
    iSettings: {
        TrackingSettingName: 'allowtracking',
    }
    //TODO
    // --status -enum(1,2) --Done
    // --severity -enum (success,error) --Done
    // --constants - (message,hardcoded table fieldname)
};

export enum Status {
    ACTIVE = 1,
    INACTIVE = 2,
}

export enum Severity {
    Success = "success",
    Error = "error",
    Warn = "warn",
}

export enum FormControl {
    Dropdown = 1,
    MultiSelect = 11,
    Checkbox = 2,
    RadioButton = 3,
    Number = 19,
    Decimal = 20
}

export enum Answer {
    Yes = "Yes",
    No = "No",
}

export enum MenuItems {
    //Product
    Type = "Type",
    Category = "Category",
    Field = "Field Data",
    Visibility = "Visibility",
    CustomField = "Custom Field",
    UOM = "UOM",
    VISIBILITY = "Visibility",
    TAG = "Tag",

    //Pricebook
    Pricing = "Pricing",
    AssignPrice = "Assign Pirce Discount",


    //Setup
    PaymentTerm = "Payment Term",
    PaymentMethods = "Payment Method",
    VendorPaymentTerm = "Vendor Payment Term",
    VendorPaymentMethods = "Vendor Payment Method",
    ShippingMethods = "Shipping Carrier",
    ShippingTerms = "Shipping Term",
    Discount = "Discount",
    AdditionalFees = "Additional Fees",
    Order = "OrderSource",
    Tax = "Tax Rate",
    FOB = "FOB Point",
    Uom = "UOM",
    PackBox = "Pack Box",
    TaxCountry = "Tax Country",

    //Location
    Location = "Location",
    Bin = "Bin",
    LocationField = "Field",
    LocationCustomField = "Custom Field",

    //Custom
    List = "Custom Field",
    Section = "Section",
    //   PackBox = "PackBox"
}

// todo createdBy etc
export const CommonCustomAttributes = {
    createdBy: 9,
    createdDate: "2021-07-26T11:57:45.944Z",
    createdSource: "system",
    createdUser: "system",
    id: 0,
    isActive: true,
    isDefault: true,
    name: "Estimates,SalesOrders,Invoices",
    displayName: "Estimates,SalesOrders,Invoices",
    stages: "",
    status: "",
    systemGenerated: true,
    updateSource: "system",
    updatedBy: 9,
    updatedDate: "2022-01-03T13:53:02.929Z",
};

export enum SignatureType {
    Estimate = "Estimate",
    SalesOrder = "SalesOrder",
    Invoice = "Invoice",
    CreditMemo = "CreditMemo"
}

export const tabHeaders: string[] = ['Serial Details', 'Activation Details', 'Residual Details', 'Commission Details', 'Spiff Details']